class SmoothScroll extends HTMLElement {
  constructor() {
    super();

    this.trigger = this.querySelector(".js-trigger");
    this.anchor = this.trigger.hash.slice(1);

    this.trigger.addEventListener("click", event => this.scrollToSection(event));
  }

  scrollToSection(event) {
    event.preventDefault();

    const section = document.getElementById(this.anchor);

    if (section) {
      const target = section.getBoundingClientRect().top;
      const offset = document.documentElement.scrollTop;
      const header = document.documentElement.style.getPropertyValue("--mobile-header-height");
      const sticky = document.querySelector("sticky-navigation").getBoundingClientRect().height;
      const y = target + offset - sticky - header.replace("px", "");

      requestAnimationFrame(() => window.scrollTo({ top: y, behavior: "smooth" }));
    }
  }
}

customElements.define("smooth-scroll", SmoothScroll);